import { render, staticRenderFns } from "./GptBox.vue?vue&type=template&id=e21ff39e&"
import script from "./GptBox.vue?vue&type=script&lang=js&"
export * from "./GptBox.vue?vue&type=script&lang=js&"
import style0 from "./GptBox.vue?vue&type=style&index=0&id=e21ff39e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports